import React, { useMemo, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const FormPhoneInput = ({
  label = "Telefone",
  name = "phone",
  placeholder = "Informe seu telefone",
  help = "",
  float = false,
  value = "",
  onChange,
  required = false,
  disabled = false,
  readOnly = false,
  defaultCountry = "BR",
  international = true,
  countryCallingCodeEditable = false,
  limitMaxLength = true,
  invalid = false,
  autoComplete = "tel",
  inputClassName = "",
  containerClassName = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const wrapperClassName = useMemo(() => {
    const base = float ? "form-floating PhoneInputFloating" : "form-group PhoneInputGroup";
    const hasUserValue = typeof value === "string" ? value.trim().length > 0 : !!value;
    // No modo internacional, o componente exibe o DDI (ex.: +55) mesmo antes do usuário digitar.
    // Para evitar sobreposição do label, consideramos isso como "preenchido" no form-floating.
    const hasCallingCodeDisplayed =
      float && international && !!defaultCountry && countryCallingCodeEditable === false;
    const filled = hasUserValue || hasCallingCodeDisplayed ? " has-value" : "";
    const focused = isFocused ? " is-focused" : "";
    return `${base}${filled}${focused}`.trim();
  }, [float, value, isFocused, international, defaultCountry, countryCallingCodeEditable]);

  const normalizedValue = value || "";

  const handleChange = (nextValue) => {
    if (typeof onChange === "function") {
      onChange(nextValue || "");
    }
  };

  const isValid =
    !normalizedValue ||
    (typeof normalizedValue === "string" &&
      normalizedValue.startsWith("+") &&
      isValidPhoneNumber(normalizedValue));

  const showInvalid = invalid || (required && !!normalizedValue && !isValid);

  return (
    <div
      className={wrapperClassName}
      onFocusCapture={() => setIsFocused(true)}
      onBlurCapture={() => setIsFocused(false)}
    >
      {!float && label && (
        <label htmlFor={name} className="form-label">
          {label}
        </label>
      )}

      <PhoneInput
        id={name}
        name={name}
        placeholder={float ? " " : placeholder}
        value={normalizedValue}
        onChange={handleChange}
        defaultCountry={defaultCountry}
        international={international}
        countryCallingCodeEditable={countryCallingCodeEditable}
        limitMaxLength={limitMaxLength}
        disabled={disabled || readOnly}
        readOnly={readOnly}
        className={`PhoneInputBootstrap ${containerClassName}`.trim()}
        numberInputProps={{
          className: `form-control PhoneInputBootstrapInput${showInvalid ? " is-invalid" : ""} ${
            inputClassName || ""
          }`.trim(),
          required,
          autoComplete,
          inputMode: "tel",
        }}
        countrySelectProps={{
          className: `PhoneInputBootstrapCountry${showInvalid ? " is-invalid" : ""}`,
          disabled: disabled || readOnly,
        }}
      />

      {float && label && <label htmlFor={name}>{label}</label>}

      {help && <small className="form-text text-muted">{help}</small>}
    </div>
  );
};

export default FormPhoneInput;
